var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "grid-view" }, [
    _c(
      "div",
      { staticClass: "main-content" },
      [
        _c(
          "div",
          { staticClass: "operations", staticStyle: { "margin-top": "5px" } },
          [
            _c(
              "div",
              { staticClass: "filters" },
              [
                _c(
                  "el-form",
                  {
                    attrs: {
                      inline: true,
                      "label-width": "50px",
                      "label-position": "left"
                    },
                    nativeOn: {
                      submit: function($event) {
                        $event.preventDefault()
                        _vm.filter.pageNum = 1
                        _vm.toQuery()
                      }
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("common.btn.query") } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "310px" },
                          attrs: {
                            placeholder: _vm.$t(
                              "CargoMsg.Cargo_EnterKeyWordsToStartFuzzySearch"
                            )
                          },
                          model: {
                            value: _vm.filter.likeName,
                            callback: function($$v) {
                              _vm.$set(_vm.filter, "likeName", $$v)
                            },
                            expression: "filter.likeName"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c("div", { staticClass: "triggers" }, [
              _c(
                "div",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          _vm.filter.pageNum = 1
                          _vm.toQuery()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.query")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.addHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.new")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.editHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.edit")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "danger" },
                      on: { click: _vm.removeHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.delete")))]
                  ),
                  _vm.showBtn
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.onSendEmail }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("Information.EmailRemindertestOnly"))
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm.showBtn
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.onSplit }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("Information.SplitDataBecomesNewData")
                            )
                          )
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "el-upload",
                    {
                      ref: "upload",
                      staticStyle: {
                        display: "inline-block",
                        "margin-left": "5px"
                      },
                      attrs: {
                        action:
                          _vm.URL.mdm.sensitiveWord.importSensitiveWordUrl,
                        headers: {
                          sessionId: _vm.sessionId,
                          language:
                            _vm.$store.getters.language === "zh"
                              ? "zh_CN"
                              : _vm.$store.getters.language === "ja"
                              ? "ja_JP"
                              : "en_US"
                        },
                        "show-file-list": false,
                        accept: ".xls, .xlsx",
                        "before-upload": _vm.beforeOrderUpload,
                        "on-error": _vm.handleError,
                        "on-success": _vm.uploadExcelSuccess,
                        data: {
                          branchId: _vm.$store.getters.currentOfficeId,
                          wordField: _vm.wordField
                        }
                      }
                    },
                    [
                      _c("el-button", { attrs: { type: "primary" } }, [
                        _vm._v(_vm._s(_vm.$t("SeaExport.import")))
                      ])
                    ],
                    1
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.downLoadTemplate()
                        }
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("CargoMsg.Cargo_DownImportTemplate"))
                      )
                    ]
                  )
                ],
                1
              )
            ])
          ]
        ),
        _c(
          "div",
          { staticClass: "section grid-wrapper" },
          [
            _c("cargo-ag-grid", {
              attrs: {
                "config-module": "1001022",
                "grid-options": _vm.gridOptions,
                "column-defs": _vm.columnDefs,
                "row-data": _vm.rowData
              },
              on: {
                gridReady: function(params) {
                  _vm.gridApi = params.api
                }
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "pagination-wrapper" },
          [
            _c("cargo-pagination", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.total > 0,
                  expression: "total>0"
                }
              ],
              attrs: {
                total: _vm.total,
                page: _vm.filter.pageNum,
                limit: _vm.filter.pageSize
              },
              on: {
                "update:page": function($event) {
                  return _vm.$set(_vm.filter, "pageNum", $event)
                },
                "update:limit": function($event) {
                  return _vm.$set(_vm.filter, "pageSize", $event)
                },
                pagination: _vm.toQuery
              }
            })
          ],
          1
        ),
        _c("sensitive-add-dialog", {
          attrs: { visible: _vm.addDialogVisible, "word-field": _vm.wordField },
          on: {
            "update:visible": function($event) {
              _vm.addDialogVisible = $event
            },
            refreshGrid: function($event) {
              return _vm.toQuery()
            },
            close: function($event) {
              _vm.addDialogVisible = false
            }
          }
        }),
        _c("sensitive-edit-dialog", {
          attrs: {
            visible: _vm.editDialog.visible,
            "word-uuid": _vm.editDialog.wordUuid,
            "word-field": _vm.wordField
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.editDialog, "visible", $event)
            },
            refreshGrid: function($event) {
              return _vm.toQuery()
            },
            close: function($event) {
              _vm.editDialog.visible = false
            }
          }
        }),
        _c("import-result", {
          attrs: {
            visible: _vm.importResultDialog.visible,
            result: _vm.importResultDialog.result
          },
          on: {
            continueImporting: _vm.continueImporting,
            close: _vm.closeImportResultDialog
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }